<template>
    <div class="news">
        <!-- <div class="toolbar">
            <toolbar></toolbar>
        </div> -->
        <div class="sidebar">
            <!-- <card></card> -->
            <list></list>
        </div>
        <div class="main">
            <chattitle></chattitle>
            <message></message>
            <usertext></usertext>
        </div>
    </div>
</template>
<script>
import card from './components/card.vue';
import list from './components/list.vue';
import message from './components/message.vue';
import usertext from './components/usertext.vue';
import toolbar from './components/toolbar.vue';
import chattitle from './components/chattitle.vue';
export default {
    name: 'ChatRoom',
    data() {
        return {};
    },
    mounted() {
        //初始化数据
        this.$store.dispatch('chat/initData');
    },
    created(){
        this.$store.commit('newChat/SetOnlines',true);
    },
    beforeDestroy(){
        this.$store.commit('newChat/SetOnlines',false);
    },
    // created() {
    //     // //在页面加载时读取sessionStorage里的状态信息
    //     // if (sessionStorage.getItem("state") ) {
    //     //   this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    //     // }

    //     //在页面刷新时将vuex里的最新信息保存到sessionStorage里
    //     window.addEventListener('beforeunload', () => {
    //         sessionStorage.setItem('state', JSON.stringify(this.$store.state));
    //     });
    // },
    components: {
        toolbar,
        card,
        list,
        message,
        usertext,
        chattitle
    }
};
</script>
<style lang="scss" scoped>
.news {
    width: 100%;
    height: 100%;
    background-color: #fff;
    .toolbar {
        float: left;
        color: #f4f4f4;
        background-color: #2e3238;
        width: 60px;
    }
    .sidebar {
        float: left;
        color: #000000;
        background-color: #eceae8;
        width: 240px;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-right: 0.5px solid #c7d2db;
    }
    .main {
        position: relative;
        overflow: hidden;
        background-color: #eee;
        height: 100%;
    }
}
</style>
